<template>
  <!-- :href="aHref"  -->
  <div style="margin-top: 24px">
    <a class="push-list-item" @click="turnClick">
      <div class="addtime">
        {{ timeToDate(data.releaseTime) }}
      </div>
      <div class="title" v-html="data.title"></div>
    </a>
    <AdsVue ref="ads" @handleClose="turnClick" />
  </div>
</template>

<script>
import itemToolBar from "@components/sys/item-tool-bar/index";
import AdsVue from "../../../components/sys/ads";
export default {
  components: {
    itemToolBar,
    AdsVue,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    action: {
      type: String,
      default: "",
    },
    retype: {
      type: String,
      default: "",
    },
    visitlocation: {
      type: String,
      default: "",
    },
  },
  computed: {
    aHref() {
      return `/library/${this.data.id}`;
    },
  },
  methods: {
    turnClick(item) {
      if (this.visitlocation) {
        this.$store.dispatch("analysis/updateHits", {
          visitlocation: this.visitlocation,
        });
      } else {
        var visitlocation = "";
        if (this.retype == "standard") {
          visitlocation = "标准规范";
        } else if (this.retype == "information") {
          visitlocation = "政策法规";
        }
        if (visitlocation) {
          this.$store.dispatch("analysis/updateHits", {
            visitlocation: visitlocation + "-详情",
          });
        }
      }

      this.$ajax({
        type: "get",
        url: this.action,
        data: {
          id: this.data.id,
        },
        callback: (data) => {
          if (data.isView) {
            if (data.httpUrl.indexOf("<a") != -1) {
              let href = data.httpUrl.split('href="')[1].split('">')[0];
              this.judgePath(href);
            } else {
              this.judgePath(data.httpUrl);
            }
          } else {
            if (this.loading) {
              this.loading.close();
            }
            this.$refs.ads.showAdsDialog({
              relationId: item.id ? item.id : this.data.id,
              relationType: this.retype,
            });
          }
        },
      });
    },
    //判断原网站是否可以打开
    judgePath(pathUrl) {
      this.$ajax({
        type: "get",
        url: `${this.$store.state.api.baseWebUrl}/yzkj/information/isViewPlatWeb`,
        data: {
          platWebUrl: pathUrl,
        },
        callback: (data) => {
          if (data.isView) {
            //true代表当前路径可以打开
            window.open(pathUrl);
          } else {
            //路径打不开 需要访问本地页面
            this.$router.push({
              path:
                "/library/documentInfo?articleId=" +
                this.data.id +
                "&source=" +
                "library",
            });
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@css/var.scss";

.push-list-item {
  overflow: hidden;
  line-height: 1em;
  color: #333;
  display: block;
  cursor: pointer;

  &:hover {
    color: $primaryColor;
  }

  & + .push-list-item {
    margin-top: 24px;
  }

  .title {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .addtime {
    float: right;
  }
}
</style>
